// Vuex Script
// Version		          : 1.0.0.0
// Template Modified Date : 5-12-2019 10:00:00 AM
// File Created Date      : 5-12-2019 10:00:00 AM
import moment from 'moment';
import { AppConstants as _app } from '@/shared/app.constants';
const initiativeCallDuration = _app.Deadlines.Call;
const ReviewDuration = _app.Deadlines.Review;

export default {
    namespaced: true,
    //#. An object containing the data
    state: {
        multiColumn: 2,
        card: {
            type: 'Grid'
        },
        inlineEditor: {
            enabled: true,
            autoSave: true,
            emptyRow: true
        },
        actions: {
            listAction: '/api/InitiativeCallDeadline/List/',
            deleteAction: '/api/InitiativeCallDeadline/',
            updateAction: '/api/InitiativeCallDeadline',
            createAction: '/api/InitiativeCallDeadline'
        },
        fields: {
            DeadlineId: {
                primaryKey: true
            },
            ItemId: {
                parent: true
            },
            ItemTypeId: {
                title: "Type",
                required: true,
                type: "ComboBox",
                autocomplete: true,
                event: true
            },
            StartDate: {
                required: true,
                displayCurrentDate: false,
                type: "Date",
                hint: 'MM-DD-YYYY',
                sortable: true,
                title: "Start Date",
                event: true
            },
            EndDate: {
                required: true,
                displayCurrentDate: false,
                type: "Date",
                hint: 'MM-DD-YYYY',
                sortable: true,
                title: "End Date"
            },
        },
    },
    //#. Used to access data from the state tree of the store
    getters: {},

    //#. Handler functions that perform modifications of data in the state tree
    mutations: {
        //#. fn_formCreated function
        formCreated(state, payload) {
        },

        //#. fn_formCancel function
        formCancel(state, payload) {
        },

        //#. fn_recordCreated function
        recordCreated(state, payload) {
        },

        //#. fn_recordUpdated function
        recordUpdated(state, payload) {
        },

        //#. fn_recordDeleted function
        recordDeleted(state, payload) {
        },

        //#. fn_loadingRecords function
        loadingRecords(state, payload) {
        },

        //#. fn_recordsLoaded function
        recordsLoaded(state, payload) {
        },

        //#. fn_selectionChanged function
        selectionChanged(state, context) {
        },

        //#. fn_startDateChange function
        startDateChange(state, context) {
            let selectedDay = context.payload;

            let initiativeCallEndDate = moment(selectedDay).add(initiativeCallDuration, 'days').format('DD/MM/YYYY');
            if(state.formData[0].ItemTypeId && state.formData[0].EndDate == '') {
                state.formData[0].EndDate = initiativeCallEndDate
            }
        },

        //#. fn_itemTypeIdChange function
        itemTypeIdChange(state, context) {
            let initiativeCallEndDate = state.formData[0].EndDate;

            if(state.formData[1] && state.formData[1].ItemTypeId.Value == 66) {
                let reviewStartDate = moment(initiativeCallEndDate, 'DD/MM/YYYY').add(1, 'days').format('DD/MM/YYYY');
                let reviewEndDate = moment(reviewStartDate, 'DD/MM/YYYY').add(ReviewDuration, 'days').format('DD/MM/YYYY');

                state.formData[1].StartDate = reviewStartDate;
                state.formData[1].EndDate = reviewEndDate;
            }
        }
    },

    //#. Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
    actions: {
        //#. formCreated event will be fired
        formCreated: ({ commit, rootState }, payload) => {
            commit('formCreated', { rootState, payload });
        },

        //#. formCancel event will be fired
        formCancel: ({ commit, rootState }, payload) => {
            commit('formCancel', { rootState, payload });
        },

        //#. recordAdded event will be fired
        recordCreated: ({ commit, rootState }, payload) => {
            commit('recordCreated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordUpdated: ({ commit, rootState }, payload) => {
            commit('recordUpdated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordDeleted: ({ commit, rootState }, payload) => {
            commit('recordDeleted', { rootState, payload });
        },
        //#. loadingRecords event will be fired
        loadingRecords: ({ commit, rootState }, payload) => {
            commit('loadingRecords', { rootState, payload });
        },

        //#. recordsLoaded event will be fired
        recordsLoaded: ({ commit, rootState }, payload) => {
            commit('recordsLoaded', { rootState, payload });
        },

        //#. selectionChanged event will be fired	
        selectionChanged: ({ commit, rootState }, payload) => {
            commit('selectionChanged', { rootState, payload });
        },

        //#. startDateChange event will be fired
        startDateChange: ({ commit, rootState }, payload) => {
            commit('startDateChange', { rootState, payload });
        },

        //#. itemTypeIdChange event will be fired
        itemTypeIdChange: ({ commit, rootState }, payload) => {
            commit('itemTypeIdChange', { rootState, payload });
        }
    }
}
